
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/news-events/news/[categorySlug]/[titleSlug]",
      function () {
        return require("private-next-pages/about-us/news-events/news/[categorySlug]/[titleSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/news-events/news/[categorySlug]/[titleSlug]"])
      });
    }
  